import React, { useEffect } from 'react'
import { InView } from 'react-intersection-observer'
import { useCookieConsent } from '@sainsburys-tech/boltui-hooks'
import { useYourekoContext } from '../../providers/Youreko/YourekoContext'
import { TRACKING_EVENTS, raiseYourekoEvent } from '../../helpers/youRekoHelper'

import { Placeholder } from './Youreko.styles'

const YOUREKO_SCRIPT_URL = 'https://static.youreko.com/js/partners/gb/argos/youreko.energy-review.argos.all.min.js'

const injectYourekoScript = () => {
  const yourekoScriptId = 'youreko-script'
  if (!document.getElementById(yourekoScriptId)) {
    const yourekoScript = document.createElement('script')
    yourekoScript.id = yourekoScriptId
    yourekoScript['data-test'] = yourekoScriptId
    yourekoScript.async = true
    yourekoScript.src = YOUREKO_SCRIPT_URL
    document.head.appendChild(yourekoScript)
  }
}

const Youreko = () => {
  const isYourekoBrandAndCategoryValid = useYourekoContext()
  const hasMarketingCookieConsent = useCookieConsent('marketing')
  const isYourekoEnabled = isYourekoBrandAndCategoryValid && hasMarketingCookieConsent

  const onView = inView => {
    if (inView) {
      raiseYourekoEvent(TRACKING_EVENTS.IN_VIEW)
    }
  }

  useEffect(() => {
    // Adding Youreko script if brand, supported categories, and marketing consent given and valid
    if (isYourekoEnabled) injectYourekoScript()
  }, [injectYourekoScript, isYourekoEnabled])

  return isYourekoEnabled ? (
    <InView as='div' onChange={onView} threshold={0.2} triggerOnce>
      <Placeholder className='youreko-placeholder' data-test='youreko-placeholder' />
    </InView>
  ) : null
}

export default Youreko
